import { render } from "./QuestionTimer.vue?vue&type=template&id=48d415fe"
import script from "./QuestionTimer.vue?vue&type=script&lang=js"
export * from "./QuestionTimer.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/dgvt/dgvt-fuchs.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__